import React from "react";
import {
  Button, DialogActions, DialogContent, Grid
} from '@mui/material';
import TextInput from "@/common/components/text-input/text-input";
import Dropdown from "@/common/components/dropdown/dropdown";
import SwitchInput from "@/common/components/switch-input/switch-input";
import AnimateButton from "@/from-theme/components/@extended/AnimateButton";
import { FormattedMessage } from 'react-intl';
import useCreateEditProductMaster from "./hooks/useCreateEditProductMaster";
import useGetCategoryNameOptions from "@/common/hooks/useGetCategoryMaster";
import PropTypes from "prop-types";
import { apiStatuses } from "@/store/api/constants";
import Spinner from "@/common/components/spinner/spinner";
import ErrorInPage from "@/common/components/error-in-page/error-in-page";

function CreateEditProductMaster({
  closeModal, activeEditId
}) {

  const { getCategoryNameOptions, getCategoryNameLoading } = useGetCategoryNameOptions();
  const {
    values, formik, getEditProductMasterStatus,
    getEditProductMasterErrMsg, saveProductMasterStatus, updateProductMasterStatus
  } = useCreateEditProductMaster(activeEditId);

  const isPending = [saveProductMasterStatus, updateProductMasterStatus]
  .includes(apiStatuses.pending);

  const {
    productCode, productName, categoryId, activeStatus
  } = values;

  console.log(values,'values')

  return (
    <>
      {
        getEditProductMasterStatus === apiStatuses.pending && activeEditId
        && <Spinner />
      }

      {getEditProductMasterStatus === apiStatuses.rejected && activeEditId && (
        <ErrorInPage message={getEditProductMasterErrMsg} />
      )}

      {(getEditProductMasterStatus === apiStatuses.succeeded || !activeEditId) &&
        <form onSubmit={formik.handleSubmit}>
          <DialogContent >
            <Grid container spacing={1.25} >
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="product-code" size="small" fullWidth
                  value={productCode}
                  inputLabel="product-code"
                  formik={formik}
                  name="productCode"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <TextInput
                  placeholder="product-name" size="small" fullWidth
                  value={productName}
                  inputLabel="product-name"
                  formik={formik}
                  name="productName"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={6}>
                <Dropdown
                  options={getCategoryNameOptions}
                  loading={getCategoryNameLoading}
                  placeholder="category-name"
                  inputLabel="category-name"
                  value={categoryId}
                  formik={formik}
                  name="categoryId"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                <SwitchInput
                  inputLabel="activeStatus"
                  leftLabel="inactive"
                  rightLabel="active"
                  value={activeStatus}
                  formik={formik}
                  name="activeStatus"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="error" onClick={closeModal} disabled={isPending} 
            variant="outlined" sx={{ mr: 1 }}>
              <FormattedMessage id={"cancel"} />
            </Button>
            <AnimateButton>
              <Button type="submit" variant="contained" disabled={isPending} sx={{ mr: 1 }}>
                <FormattedMessage id={"save"} />
              </Button>
            </AnimateButton>
          </DialogActions>
        </form>
      }
    </>
  )
}


CreateEditProductMaster.propTypes = {
  closeModal: PropTypes.func.isRequired,
  activeEditId: PropTypes.bool,
};

CreateEditProductMaster.defaultProps = {
  activeEditId: 0,
};

export default CreateEditProductMaster;